import { createBrand, type BrandForm as BrandFormValues } from '@gozoki/api'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { BrandForm } from '~/components/routes/categories/BrandForm'
import { getAxiosErrorMessage } from '~/lib/utils'
import { useRights } from '~/utils/hooks'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/brand/new')({
  staticData: {
    permission: ['edit', 'categories'],
  },
  component: AddBrandPage,
})
withRoutePermissions(Route)

const EMPTY_BRAND: BrandFormValues = {
  name: '',
  image: null,
}

function AddBrandPage() {
  const navigate = useNavigate()
  const isUserAdmin = useRights(['ADMIN'])

  const { mutateAsync: create } = useMutation({ mutationFn: createBrand })

  const navigateBack = () => navigate({ to: '/categories/brands' })

  return (
    <BrandForm
      title="Ajouter une marque"
      submitLabel="Ajouter"
      canEdit={isUserAdmin}
      defaultValues={EMPTY_BRAND}
      onCancel={navigateBack}
      onSubmit={async (values) => {
        try {
          await create(values)
          navigateBack()
        } catch (error) {
          toast.error(getAxiosErrorMessage(error))
        }
      }}
    />
  )
}
